import { IState } from '../../store';

export function selectOfferFormattedAreaParts(state: IState) {
  return state.offerData.formattedAreaParts;
}
